// @flow
import React from 'react';
import { connect } from 'react-redux';

import AddGatewayUsersPopupContent from '../AddGatewayUsersPopupContent';
import Popup from '../Popup';
import * as selectors from '../../reducers';
import type { GATEWAY_TYPE } from '../../types/gateways';

type AddGatewayUsersPropTypes = {
  gateway: GATEWAY_TYPE,
}

const AddGatewayUsersPopup = ({
  gateway,
}: AddGatewayUsersPropTypes) => (
  <Popup
    id="gatewayUsersPopup"
    theme="main"
    transitionMs={600}
  >
    <AddGatewayUsersPopupContent
      gateway={gateway}
    />
  </Popup>
);

export default connect(
  state => ({
    gateway: selectors.getCurrentGateway(state),
  }),
  undefined,
)(AddGatewayUsersPopup);



// WEBPACK FOOTER //
// ./src/scripts/components/AddGatewayUserPopup/index.jsx